import ar from "react-phone-input-2/lang/ar.json";

const LOCALIZATION_BY_LANG = {
  ar,
};

export function getPhoneInputLocalization(lang) {
  return LOCALIZATION_BY_LANG[lang];
}
